import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { getNotificationGroupType, NotificationsGroupType } from './helpers';
import { NotificationStatus } from './model/NotificationStatus';

const getNotificationsState = (state: RootState) => state.notifications;

export const selectNotifications = createSelector(
  [getNotificationsState],
  (notifications) => notifications.notifications.data
);

export const selectLoadingNotifications = createSelector(
  [getNotificationsState],
  (notifications) => notifications.loadingNotifications
);

export const selectLoadingReadNotification = createSelector(
  [getNotificationsState],
  (notifications) => notifications.loadingReadNotification
);

export const selectNewNotifications = createSelector(
  [getNotificationsState],
  (notifications) =>
    !!notifications.notifications.data.find(
      (notification) =>
        notification.statusToMember === NotificationStatus.unread
    )
);

export const selectUnreadCommunityNotifications = createSelector(
  [getNotificationsState],
  (notifications) =>
    notifications.notifications?.data?.filter(
      (notification) =>
        notification.statusToMember === NotificationStatus.unread &&
        NotificationsGroupType.community ===
          getNotificationGroupType(notification.type)
    ).length
);

export const selectUnreadStoriesNotifications = createSelector(
  [getNotificationsState],
  (notifications) => {
    return notifications.notifications?.data?.filter(
      (notification) =>
        notification.statusToMember === NotificationStatus.unread &&
        NotificationsGroupType.stories ===
          getNotificationGroupType(notification.type)
    ).length;
  }
);

export const selectNotificationsDrawerOpen = createSelector(
  [getNotificationsState],
  (notifications) => notifications.isOpen
);

export const selectNotificationsxMsContinuationToken = createSelector(
  [getNotificationsState],
  (notifications) => notifications.notifications.xMsContinuationToken
);
